import { useTranslation } from 'react-i18next'

export default function ReservationDuration({
    reservationDays,
    reservationHours,
}: {
    reservationDays: number
    reservationHours: number
}) {
    const { t } = useTranslation()
    const showDays = reservationDays > 0
    const showHours = reservationHours > 0 || reservationDays === 0

    return (
        <>
            {showDays ? (
                <span>{t('search.days', { count: reservationDays })}</span>
            ) : null}
            {showDays && showHours ? ' ' : null}
            {showHours ? (
                <span>{t('search.hours', { count: reservationHours })}</span>
            ) : null}
        </>
    )
}
